module.exports = __webpack_public_path__ + "static/media/Niveau_elN14_1_505036.dffcdb37.png";